export default __webpack_public_path__ + "static/media/chia seeds.8d3ddf1f.jpg";